/** Shared low-level buffer helpers for spreadsheet ingestion. Used by both the
 *  read-only DocumentViewer and the editable SheetEditor so the detection logic
 *  stays in one place. */

/** Returns true if the buffer starts with the ZIP magic bytes (PK\x03\x04),
 *  meaning the file is actually XLSX regardless of the declared MIME type. */
export const isXlsxBuffer = (buffer: ArrayBuffer): boolean => {
    if (buffer.byteLength < 4) return false;
    const b = new Uint8Array(buffer);
    return b[0] === 0x50 && b[1] === 0x4b && b[2] === 0x03 && b[3] === 0x04;
};

/** Decodes an ArrayBuffer as text, respecting UTF-16 LE/BE and UTF-8 BOMs. */
export const decodeText = (buffer: ArrayBuffer): string => {
    const b = new Uint8Array(buffer);
    if (b[0] === 0xff && b[1] === 0xfe) return new TextDecoder('utf-16le').decode(buffer.slice(2));
    if (b[0] === 0xfe && b[1] === 0xff) return new TextDecoder('utf-16be').decode(buffer.slice(2));
    if (b[0] === 0xef && b[1] === 0xbb && b[2] === 0xbf) return new TextDecoder('utf-8').decode(buffer.slice(3));
    return new TextDecoder('utf-8').decode(buffer);
};
